/*

  HEADS UP! THIS IS A GENERATED FILE!

  Changes done in this file will be overwritten on next generation from the code generator.

*/

import getAxiosInstance from 'app/config/api';
import axios from 'axios';
import domainModel from 'domain-model';
import withFormsyValidations from 'flaivy-react/components/withFormsyValidations';
import { propTypes } from 'formsy-react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import qs from 'qs';
import React, { Component } from 'react';
import { components } from 'react-select';
import Async from 'react-select/async';

const endPoint = '/orders';

let cancelTokenSource = null;

/* eslint-disable */
const MenuList = props => {
  return (
    <components.MenuList {...props}>
      <table className="table w-100 mt-n1">
        <caption>
          Lista med sökresultat,{' '}
          {props.options.length === 0
            ? 'sökningen gav inget resultat'
            : 'skriv för att söka efter fler.'}
        </caption>
        <thead className="table-light">
          <tr>
            <th className="text-nowrap text-center w-100 py-1">Ordernummer</th>

            <th className="text-nowrap text-center w-100 py-1">
              Ordernummer i Qvanti
            </th>

            <th className="text-nowrap text-center w-100 py-1">
              Leverantörens ordernummer
            </th>

            <th className="text-nowrap text-center w-100 py-1">Status</th>

            <th className="text-nowrap text-center w-100 py-1">
              Orderursprung
            </th>

            <th className="text-nowrap text-center w-100 py-1">Valuta</th>

            <th className="text-nowrap text-center w-100 py-1">
              Leveransaddress
            </th>

            <th className="text-nowrap text-center w-100 py-1">Stad</th>

            <th className="text-nowrap text-center w-100 py-1">Län</th>

            <th className="text-nowrap text-center w-100 py-1">Land</th>

            <th className="text-nowrap text-center w-100 py-1">
              Övrig leveransinformation så som t.ex. portkod eller våning
            </th>

            <th className="text-nowrap text-center w-100 py-1">
              Leverantörens leveransdatum
            </th>

            <th className="text-nowrap text-center w-100 py-1">
              Önskat leveransdatum
            </th>

            <th className="text-nowrap text-center w-100 py-1">Fakturadatum</th>

            <th className="text-nowrap text-center w-100 py-1">Orderdatum</th>

            <th className="text-nowrap text-center w-100 py-1">Ordertyp</th>

            <th className="text-nowrap text-center w-100 py-1">Ordertext</th>

            <th className="text-nowrap text-center w-100 py-1">Er referens</th>

            <th className="text-nowrap text-center w-100 py-1">
              Kundordernummer
            </th>

            <th className="text-nowrap text-center w-100 py-1">
              Telefonnummer
            </th>

            <th className="text-nowrap text-center w-100 py-1">
              Leverantörens referens
            </th>

            <th className="text-nowrap text-center w-100 py-1">E-post</th>

            <th className="text-nowrap text-center w-100 py-1">
              Fakturareferens
            </th>

            <th className="text-nowrap text-center w-100 py-1">
              Order packad på
            </th>

            <th className="text-nowrap text-center w-100 py-1">ARC-nummer</th>

            <th className="text-nowrap text-center w-100 py-1">
              Meddelande till kund
            </th>

            <th className="text-nowrap text-center w-100 py-1">
              Typ av orderflöde
            </th>
          </tr>
        </thead>
        <tbody>{props.children}</tbody>
      </table>
    </components.MenuList>
  );
};

const Option = props => {
  return (
    <tr
      id={props.innerProps.id}
      ref={props.innerRef}
      className={
        (props.isSelected ? 'table-active' : '') +
        ' ' +
        (props.isFocused ? 'bg-light' : '') +
        ' select-option'
      }
      onClick={() => {
        props.selectOption(props.data);
      }}
    >
      <td className="text-nowrap py-1">{props.data.orderNumber}</td>

      <td className="text-nowrap py-1">{props.data.qvantiOrderNumber}</td>

      <td className="text-nowrap py-1">{props.data.supplierOrderNumber}</td>

      <td className="text-nowrap py-1">{props.data.orderState}</td>

      <td className="text-nowrap py-1">{props.data.orderOrigin}</td>

      <td className="text-nowrap py-1">{props.data.currency}</td>

      <td className="text-nowrap py-1">{props.data.deliveryAddress}</td>

      <td className="text-nowrap py-1">{props.data.deliveryCity}</td>

      <td className="text-nowrap py-1">{props.data.deliveryCounty}</td>

      <td className="text-nowrap py-1">{props.data.deliveryCountry}</td>

      <td className="text-nowrap py-1">{props.data.deliveryInformation}</td>

      <td className="text-nowrap py-1">{props.data.deliveryDate}</td>

      <td className="text-nowrap py-1">{props.data.requestedDeliveryDate}</td>

      <td className="text-nowrap py-1">{props.data.invoiceDate}</td>

      <td className="text-nowrap py-1">{props.data.orderDate}</td>

      <td className="text-nowrap py-1">{props.data.orderType}</td>

      <td className="text-nowrap py-1">{props.data.remarks}</td>

      <td className="text-nowrap py-1">{props.data.yourReference}</td>

      <td className="text-nowrap py-1">{props.data.yourOrderNumber}</td>

      <td className="text-nowrap py-1">{props.data.phone}</td>

      <td className="text-nowrap py-1">{props.data.ourReference}</td>

      <td className="text-nowrap py-1">{props.data.email}</td>

      <td className="text-nowrap py-1">{props.data.invoiceReference}</td>

      <td className="text-nowrap py-1">{props.data.deliveryPalletType}</td>

      <td className="text-nowrap py-1">{props.data.ARCNumber}</td>

      <td className="text-nowrap py-1">{props.data.supplierComment}</td>

      <td className="text-nowrap py-1">{props.data.orderFlowType}</td>
    </tr>
  );
};

/* eslint-enable */
class OrderSelect extends Component {
  static get propTypes() {
    return {
      name: PropTypes.string.isRequired,
      value: PropTypes.object,
      isDisabled: PropTypes.bool,
      onChange: PropTypes.func.isRequired,
      styles: PropTypes.object,
      immutableQuery: PropTypes.object,
      ...propTypes,
    };
  }

  static get defaultProps() {
    return {
      isDisabled: false,
      value: null,
      styles: undefined,
      immutableQuery: {},
    };
  }
  constructor(props) {
    super(props);
    this.search = this.search.bind(this);
    this.selectHandler = this.selectHandler.bind(this);
    this.loadCurrentValueIfOnlyIdIsAvailable =
      this.loadCurrentValueIfOnlyIdIsAvailable.bind(this);
  }

  async selectHandler(selectedEntity) {
    const { onChange, name, setValue } = this.props;
    if (!selectedEntity) {
      onChange(name, null);
      setValue(null);
      return;
    }
    const requestUrl = `${endPoint}/${selectedEntity.id}`;
    const response = await getAxiosInstance().get(requestUrl);
    const fullEntity = response.data;
    setValue(fullEntity);
    onChange(name, fullEntity);
  }

  loadCurrentValueIfOnlyIdIsAvailable() {
    const keys = Object.keys(this.props.value);
    if (keys.length === 1 && keys[0] === 'id') {
      this.selectHandler(this.props.value);
    }
  }

  componentDidMount() {
    if (this.props.value === null) {
      return;
    }
    this.loadCurrentValueIfOnlyIdIsAvailable();
  }

  async search(inputValue) {
    const { immutableQuery } = this.props;
    const queryStr = qs.stringify({
      query: {
        cancelled: false,
        ...domainModel.order.createSearchStringQuery(inputValue),
        ...immutableQuery,
      },
      cacheBuster: new Date().getTime(),
    });
    const requestUrl = `${endPoint}?${queryStr}`;
    if (cancelTokenSource) {
      cancelTokenSource.cancel();
    }
    cancelTokenSource = axios.CancelToken.source();
    const response = await getAxiosInstance().get(`${requestUrl}`, {
      cancelToken: cancelTokenSource.token,
    });

    cancelTokenSource = null; // we never get here on a cancelled request. See api.js
    return response.data.rows;
  }

  render() {
    const {
      props: { name, value, isDisabled, isValid, styles },
      search,
    } = this;
    return (
      <Async
        cacheOptions
        instanceId={'select-' + name}
        className={!isValid ? 'border border-danger' : ''}
        components={{ MenuList, Option }}
        name={name}
        value={value}
        isDisabled={isDisabled}
        placeholder="Skriv för att söka ..."
        isClearable
        noOptionsMessage={() => ''}
        loadOptions={search}
        getOptionValue={option => option['id']}
        getOptionLabel={option =>
          [
            option.orderNumber,

            option.qvantiOrderNumber,

            option.supplierOrderNumber,

            option.orderState,

            option.orderOrigin,

            option.currency,

            option.deliveryAddress,

            option.deliveryCity,

            option.deliveryCounty,

            option.deliveryCountry,

            option.deliveryInformation,

            option.deliveryDate,

            option.requestedDeliveryDate,

            option.invoiceDate,

            option.orderDate,

            option.orderType,

            option.remarks,

            option.yourReference,

            option.yourOrderNumber,

            option.phone,

            option.ourReference,

            option.email,

            option.invoiceReference,

            option.deliveryPalletType,

            option.ARCNumber,

            option.supplierComment,

            option.orderFlowType,
          ]
            .filter(x => x)
            .join(' - ')
        }
        onChange={this.selectHandler}
        styles={styles}
      />
    );
  }
}

export default withFormsyValidations(OrderSelect, props => ({
  requiredValidation(values, value) {
    if (props.required) {
      return !!value && !_.isEmpty(value);
    }
    return true;
  },
}));
